/*global b2bFreetrialConstraint:true*/

angular.module('b2bLoginApp.validators').directive('londonValidator', function(){
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attrs) {
            if (typeof b2bFreetrialConstraint.radiusMaxLondon === 'undefined') {
                return;
            }
            if (typeof b2bFreetrialConstraint.orginalRadiusMin === 'undefined') {
                b2bFreetrialConstraint.orginalRadiusMin = b2bFreetrialConstraint.radiusMin;
                b2bFreetrialConstraint.orginalRadiusMax = b2bFreetrialConstraint.radiusMax;
            }
            var londonRegex = /^(E|EC|N|NW|SE|SW|W|WC|BR|CR|DA|EN|HA|IG|KT|RM|SM|TW|UB|WD)\d{1,2}/i;
            scope.$watch(attrs.londonValidator, function(newVal) {
                if (typeof newVal === 'undefined') {
                    return;
                }
                var isLondonPostcode = londonRegex.test(newVal);
                if (isLondonPostcode) {
                    b2bFreetrialConstraint.radiusMin = b2bFreetrialConstraint.radiusMinLondon;
                    b2bFreetrialConstraint.radiusMax = b2bFreetrialConstraint.radiusMaxLondon;
                } else {
                    b2bFreetrialConstraint.radiusMin = b2bFreetrialConstraint.orginalRadiusMin;
                    b2bFreetrialConstraint.radiusMax = b2bFreetrialConstraint.orginalRadiusMax;
                }
            });
        }
    };
});
